"use strict";
/**
 * Unified source for the possible payment quantities in the PaymentData screen.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTHER = exports.ANNUAL = void 0;
exports.ANNUAL = 'anual';
exports.OTHER = 'other';
//# sourceMappingURL=paymentQuantityTypes.js.map